// extracted by mini-css-extract-plugin
export default {"container":"carousel_container__wde3C","item":"carousel_item__FrqFb","title":"carousel_title__vDzia","content":"carousel_content__AhAm6","author":"carousel_author__82Ta0"};